import { FC } from 'react';
import { UseFormRegister, FieldError } from 'react-hook-form';
import {
  Box,
  FormControl,
  FormErrorMessage,
  FormLabel,
  SimpleGrid,
} from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';
import { EnableVerticalPodAutoScalerFormBase } from '../../FormBases/EnableVerticalPodAutoScalerFormBase/EnableVerticalPodAutoScalerFormBase';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
  error: FieldError | undefined;
  watchEnableVerticalPodAutoScaler: boolean;
};

/**
 * 編集モーダル用のVPA設定のフォームです。
 */
export const EnableVerticalPodAutoScalerForm: FC<Props> = ({
  register,
  error,
  watchEnableVerticalPodAutoScaler,
}: Props) => (
  <FormControl isInvalid={Boolean(error)}>
    <SimpleGrid templateColumns="1fr 2fr">
      <Box pl="40px">
        <FormLabel>- VPA設定</FormLabel>
      </Box>
      <EnableVerticalPodAutoScalerFormBase
        register={register}
        watchEnableVerticalPodAutoScaler={watchEnableVerticalPodAutoScaler}
      />
      <FormErrorMessage>{error && error.message}</FormErrorMessage>
    </SimpleGrid>
  </FormControl>
);
